export const PortalType = "/customer";